import React, {Component} from 'react';
import CSSModules from 'react-css-modules'
import config from '../../config'
import container from '../../helpers/container'
import {
  ContainerDivs,
  Link,
  LinkIcon,
} from '../../components'
import Styles from './About.css'

@CSSModules(Styles, {allowMultiple:true})
export default class AboutRji extends Component {
  constructor(props) {
    super(props)
    this.state = { }
  }

  componentWillMount() {
    if (typeof window !== 'undefined') {
      window.scrollTo(0,0)
    }
  }

  render() {
    const title = 'Racial Justice'
    const url = config.domain + config.routes.aboutRji

    const aysLogo = require( '../../../static/images/AYS_R+large+RGB.jpg' )
    const rjiAboutGraphic = require( '../../../static/images/about/rji-about-page-graphic.png' )
    const clipboardClockGraphic = require( '../../../static/images/about/clipboard-clock-graphic.png' )

    //
    return <div>
      {container.helmet(title, '', url)}
      <ContainerDivs>
        
        
        <header styleName='header-subpage'>
          <h1 styleName='header-subpage__headline'>{title}</h1>
          <div styleName='header-subpage__image-banner--rji' />
        </header>


        <section styleName='lede-content'>
          <br/>
          <br/>

          <p styleName='lede-content__copy'>
            <b>Public statements in support of racial justice are easy; ensuring that People of Color are hired, paid, promoted, and retained equitably is less so.</b>
          </p>

          <p styleName='lede-content__copy'>
            In May of 2020, the world witnessed the horrific murder of George Floyd, forcing many to confront and challenge systemic racism within our lives. Not only did this event force a re-evaluation of our most fundamental beliefs and institutions, but it also became a catalyst for change within American society.  
          </p>
          <p styleName='lede-content__copy'>
            In this moment of reflection, many companies have realized that advancing racial justice and diversity within their organizations can improve employee wellbeing and belonging, while also driving measurable financial returns over time. <Link xstrong to='https://www.asyousow.org/report-page/2023-capturing-the-diversity-benefit' title='Capturing the Diversity Benefit'>Research indicates</Link> that companies with diverse teams offer better management, have stronger long-term growth prospects, and see improved share value. 
          </p>
          <p styleName='lede-content__copy'>
            <b>Social Justice Funds</b> empowers investors to harness their personal economic power to support racial justice while maximizing returns. 
          </p>
        </section>


        <section styleName='section-panel'>
          <h2 styleName='section-panel__headline'>
            <i>As You Sow's</i> Racial Justice Initiative
          </h2>
          <div styleName='section-panel__content'>
            <div styleName='section-panel__copy-wrap'>
              <p styleName='section-panel__copy'>
                <i>As You Sow</i> created the <Link xstrong to='https://www.asyousow.org/our-work/social-justice/racial-justice' title='Racial Justice Initiative'>Racial Justice Initiative</Link> to educate companies on the importance of incorporating standards related to racial justice, diversity, equity, and inclusion. By showing the material benefit of cultivating a diverse workforce, with strong equity-based policies and practices, <i>As You Sow</i> helps companies further positive actions for their employees, communities, shareholders, and stakeholders. 
              </p>
            </div>
            <div styleName='section-panel__image-wrap'>
              <img src={aysLogo} alt='As You Sow'  styleName='section-panel__ays-logo'/> 
            </div>
          </div>
        </section>


        <section styleName='section-panel'>
          <h2 styleName='section-panel__headline'>
            <i>As You Sow's</i> Racial Justice Scorecard
          </h2>
          <div styleName='section-panel__content'>
            <div styleName='section-panel__copy-wrap'>
              <p styleName='section-panel__copy'>
                Following George Floyd’s murder in 2020, more than half of companies in the Russell 1000 made some type of public statement in response to the incident, with many stating their support for racial justice and pledging to create internal DEI policies that can help lead to racial justice. 
              </p>
              <p styleName='section-panel__copy'>
                Yet, progress demands more than words. Since 2020, the Racial Justice Initiative has developed Racial Justice Scorecards on the Large-Cap 3000, to monitor publicly available information on key actions related to racial equity, diversity, and inclusion disclosure and policies, and environmental justice. See the <Link xstrong to='https://www.asyousow.org/our-work/social-justice/racial-justice/data-visualization' title='Racial Justice Scorecard Data Visualization Tool'>Racial Justice Scorecard Data Visualization Tool</Link> at AsYouSow.org. 
              </p>
            </div>
            <div styleName='section-panel__image-wrap'>
              <img src={rjiAboutGraphic} alt='Racial Justice Scorecard'  styleName='section-panel__rji-icon'/>
            </div>
          </div>
        </section>


        <section styleName='section-panel'>
          <div styleName='section-panel__image-wrap'>
            <img src={clipboardClockGraphic} alt='Visit our Action Toolkit'  styleName='section-panel__graphic-image'/>
          </div>
          <h2 styleName='section-panel__headline section-panel__headline--center section-panel__headline--purple'>
            Visit our Action Toolkit
          </h2>
          <div styleName='section-panel__narrow-content'>
            <ul styleName='section-panel__list section-panel__list--flush'>
              <li>
                Learn how to make a change and align your investments with racial justice
              </li>
              <li>
                Ask your financial advisor about Social Justice investing
              </li>
              <li>
                Push your employer to provide socially just investment options
              </li>
            </ul>

            <Link roundbutton to={config.routes.toolkit} title='Take action'>
              Take action
            </Link>
          </div>
        </section>


      </ContainerDivs>
    </div>
  }
}
